import { throttle } from 'lodash'

const THROTTLE_INTERVAL = 10

export default {
  init(handler) {
    this.touchPos = 0
    this.handler = handler

    const throttledHandleScroll = throttle(
      (e) => this.handleScroll(e),
      THROTTLE_INTERVAL,
      {
        trailing: false
      },
      { passive: false }
    )

    document.addEventListener('wheel', throttledHandleScroll)

    document.addEventListener('touchmove', throttledHandleScroll)

    document.addEventListener('touchstart', (e) => {
      this.touchPos = e.touches[0].pageY
    })
  },

  getForward(e) {
    let forward = true

    if (e.type === 'wheel') forward = 0 < e.deltaY
    if (e.type === 'touchmove') {
      forward = 0 < this.touchPos - e.touches[0].pageY
      this.touchPos = e.touches[0].pageY
    }

    return forward
  },

  handleScroll(e) {
    e.stopPropagation && e.stopPropagation()

    const forward = this.getForward(e)
    const unit = forward ? 1 : -1

    this.handler(unit)
  }
}
